<!--
  ~ VNCtalk - an enterprise real-time communication solution including chat, video and audio conferencing, screen sharing, voice messaging, file sharing, broadcasts, document collaboration and much more.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="common-dialog-component">
  <vnc-dialog [classes]="isMobileSize ? ['common-dialog', 'mobile-size'] : ['common-dialog']" [headerTemplate]="headerTemplate"
    [footerTemplate]="footerTemplate" [bodyTemplate]="bodyTemplate">
  </vnc-dialog>
  <ng-template #bodyTemplate>
    <div class="content-wrapper">
      <vnc-input id="linkName" [form]="linkName" [showLabel]="true" placeholder="{{'LINK_NAME'|translate}}" size="l" type="text">
      </vnc-input>

      <div class="form-option">
        <vnc-header title="{{ 'PERMISSIONS' | translate}}" type="title" size="l">
        </vnc-header>
        <ng-container *ngIf="!isMobileSize">
          <mat-radio-group [(ngModel)]="permission">
            <div class="permission-option">
              <mat-radio-button value="1">{{ 'DOWNLOAD_VIEW' | translate}}</mat-radio-button>
            </div>
            <ng-container *ngIf="file.type === 'dir'">
              <div class="permission-option">
                <mat-radio-button value="5">{{ 'DOWNLOAD_VIEW_UPLOAD' | translate}}</mat-radio-button>
              </div>
              <div class="permission-option">
                <mat-radio-button value="15">{{ 'DOWNLOAD_VIEW_EDIT' | translate}}</mat-radio-button>
              </div>
              <div class="permission-option">
                <mat-radio-button value="4">{{ 'UPLOAD_ONLY' | translate}}</mat-radio-button>
              </div>
            </ng-container>
          </mat-radio-group>
        </ng-container>
        <ng-container *ngIf="isMobileSize">
            <div class="permission-option">
              <vp-dropdown-item (onClickEvent)="permission = '1'" itemType="filter-check-unchecked" label="{{ 'DOWNLOAD_VIEW' | translate}}" [isActive]="permission === '1'" [isSelectOption]="true"></vp-dropdown-item>
            </div>
            <ng-container *ngIf="file.type === 'dir'">
              <div class="permission-option">
                <vp-dropdown-item (onClickEvent)="permission = '5'" itemType="filter-check-unchecked" label="{{ 'DOWNLOAD_VIEW_UPLOAD' | translate}}" [isActive]="permission === '5'" [isSelectOption]="true"></vp-dropdown-item>
              </div>
              <div class="permission-option">
                <vp-dropdown-item (onClickEvent)="permission = '15'" itemType="filter-check-unchecked" label="{{ 'DOWNLOAD_VIEW_EDIT' | translate}}" [isActive]="permission === '15'" [isSelectOption]="true"></vp-dropdown-item>
              </div>
              <div class="permission-option">
                <vp-dropdown-item (onClickEvent)="permission = '4'" itemType="filter-check-unchecked" label="{{ 'UPLOAD_ONLY' | translate}}" [isActive]="permission === '4'" [isSelectOption]="true"></vp-dropdown-item>
              </div>
            </ng-container>
        </ng-container>


      </div>
      <div class="form-option">
        <vnc-header title="{{ 'COMMON.PASSWORD' | translate}}" type="title" size="l">
        </vnc-header>

        <vnc-input class="password-input" [form]="password" [showLabel]="true" placeholder="{{'COMMON.PASSWORD'|translate}}" size="l" type="text"
          [dataType]="dataType" [iconActionTemplate]="dataType === 'password' ? passwordIcon : eyeIcon" (actionItem)="toggleType()" actionItemTootip="{{ (dataType === 'password' ? 'SHOW_CHARACTER' : 'HIDE_CHARACTER') | translate}}">
        </vnc-input>
        <form [formGroup]="owncloudGroup">
          <mat-form-field class="date-picker-input">
            <input (click)="picker.open()" matInput [min]="minDate" formControlName="expirationDate" [matDatepicker]="picker" placeholder="{{'EXPIRATION_DATE'|translate}}" required readonly>
            <span (click)="picker.open()" class="datepicker-icon-trigger">
              <ng-template [ngTemplateOutlet]="datePickerIcon">
              </ng-template>
            </span>
            <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle> -->
            <mat-datepicker #picker panelClass="create-filter-date-picker"></mat-datepicker>
          </mat-form-field>
        </form>

      </div>
    </div>
  </ng-template>
<ng-template #eyeIcon>
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path d="m8.409 5.057.05.096L16.282 18.7c-1.327.517-2.77.801-4.281.801-5 0-9.27-3.11-11-7.5a11.868 11.868 0 0 1 7.409-6.943zM12 4.5c5 0 9.27 3.11 11 7.5a11.89 11.89 0 0 1-4.92 5.815l-1.001-1.733a9.85 9.85 0 0 0 3.713-4.035l.022-.048-.022-.046a9.823 9.823 0 0 0-8.502-5.449L12 6.5c-.15 0-.299.003-.447.01l-1.104-1.909A11.908 11.908 0 0 1 12 4.5zM7.545 7.57a9.85 9.85 0 0 0-4.197 4.111l-.163.318.023.048a9.823 9.823 0 0 0 8.502 5.449l.29.004c.417 0 .828-.026 1.233-.077l-.832-1.443a4 4 0 0 1-3.647-6.317L7.545 7.57zm2.462 4.265a2.001 2.001 0 0 0 1.14 1.975l-1.14-1.975zM16 12c0 .577-.122 1.125-.342 1.62l-3.232-5.598A4.001 4.001 0 0 1 16 12z" fill="#8B96A0" fill-rule="evenodd"/>
  </svg>
</ng-template>
<ng-template #passwordIcon>
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4.5c5 0 9.27 3.11 11 7.5-1.73 4.39-6 7.5-11 7.5S2.73 16.39 1 12c1.73-4.39 6-7.5 11-7.5zm0 2a9.82 9.82 0 0 0-8.652 5.181l-.163.318.023.048a9.823 9.823 0 0 0 8.502 5.449l.29.004a9.822 9.822 0 0 0 8.792-5.453l.022-.048-.022-.046a9.823 9.823 0 0 0-8.502-5.449L12 6.5zM12 8a4 4 0 1 1-.001 8.001A4 4 0 0 1 12 8zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 12 10z" fill="#8B96A0" fill-rule="evenodd"/>
</svg>
</ng-template>

  <ng-template #headerTemplate>
    <vnc-header *ngIf="!isMobileSize" style="width:100%;" title="{{ (isEdit ? 'EDIT_PUBLIC_LINK' : 'PUBLIC_LINK') | translate }}" type="title-close" size="l"
      (onCloseClick)="cancel()" [showCloseIcon]="true" closeIconToolTip="{{ 'CLOSE' | translate }}">
    </vnc-header>
    <vnc-mobile-header style="width: 100%" (darkSuffixButtonPress)="share()" (darkBackPress)="cancel()" *ngIf="!isEdit && isMobileSize" darkSuffixIcon="mdi-check" headerType="dark-back-more"
    darkBackMorePlaceHolder="{{ 'PUBLIC_LINK' | translate }}"></vnc-mobile-header>
    <vnc-mobile-header style="width: 100%" (darkSuffixButtonPress)="share()" (darkBackPress)="cancel()"
    *ngIf="isEdit && isMobileSize" darkSuffixIcon="mdi-check" headerType="dark-back-more"
    (onPrefixIconClick)="copy()"
    (onSufixIcon1Click)="delete()"
    [prefixIconTemplate]="prefixIconTemplate" [sufixIconTemplate1]="sufixIconTemplate1"
    darkBackMorePlaceHolder="{{ 'EDIT_PUBLIC_LINK' | translate }}"></vnc-mobile-header>

  </ng-template>
  <ng-template #prefixIconTemplate>
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 5c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2zm0 2H8v14h11V7zm-4.064-5a1 1 0 0 1 .117 1.993L14.936 4H7.333c-1.235 0-2.246.96-2.328 2.174L5 6.334v11.683a1 1 0 0 1-1.993.116L3 18.017V6.333a4.333 4.333 0 0 1 4.123-4.328L7.333 2h7.603z" fill="#FFF" fill-rule="evenodd"/>
    </svg>
  </ng-template>
  <ng-template #sufixIconTemplate1>
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 7v11.286C18 19.775 16.809 21 15.333 21H8.667C7.19 21 6 19.775 6 18.286V7h12zm-2 2H8v9.286c0 .363.26.66.578.708l.089.006h6.666c.358 0 .667-.318.667-.714V9zm-3-6a2 2 0 0 1 1.733 1H18a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2h3.268A2 2 0 0 1 11 3h2z" fill="#FFF" fill-rule="evenodd"/>
    </svg>
  </ng-template>

  <ng-template #footerTemplate>
    <vnc-footer *ngIf="!isMobileSize" secondaryLabel="{{ 'CANCEL' | translate }}" primaryLabel="{{ (isEdit ? 'UPDATE' : 'CREATE') | translate }}"
      (onPrimaryClick)="share()" (onSecondaryClick)="cancel()" [type]="'secondary-primary'" [color]="'white'">
    </vnc-footer>
  </ng-template>
</div>
<ng-template #datePickerIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/date-today-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M15.5,3 C16.3284271,3 17,3.67157288 17,4.5 L17,5 L18,5 C19.5976809,5 20.9036609,6.24891996 20.9949073,7.82372721 L21,8 L21,18 C21,19.5976809 19.75108,20.9036609 18.1762728,20.9949073 L6,21 C4.40231912,21 3.09633912,19.75108 3.00509269,18.1762728 L3,18 L3,8 C3,6.40231912 4.24891996,5.09633912 5.82372721,5.00509269 L7,5.005 L7,4.5 C7,3.67157288 7.67157288,3 8.5,3 C9.32842712,3 10,3.67157288 10,4.5 L10,5.003 L14,5.002 L14,4.5 C14,3.67157288 14.6715729,3 15.5,3 Z M18,7 L6,7 C5.48716416,7 5.06449284,7.38604019 5.00672773,7.88337887 L5,8 L5,18 C5,18.5128358 5.38604019,18.9355072 5.88337887,18.9932723 L6,19 L18,19 C18.5128358,19 18.9355072,18.6139598 18.9932723,18.1166211 L19,18 L19,8 C19,7.44771525 18.5522847,7 18,7 Z M7.5,9 C8.32842712,9 9,9.67157288 9,10.5 C9,11.3284271 8.32842712,12 7.5,12 C6.67157288,12 6,11.3284271 6,10.5 C6,9.67157288 6.67157288,9 7.5,9 Z" id="Combined-Shape" fill="#8B96A0"></path>
      </g>
  </svg>
</ng-template>